import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsProjectsCategoriesDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-projects-categories-delete',
	path: '/secure/admin/projectcategories/DeleteProjectCategory([!%]?[\\w]*).jspa',
};
